export const UserMfaSettings = [
  // samples
  {
    id: 'test-mfa1@test.com',
    isMfaRequired: false,
  },
  {
    id: 'test2@test.com',
    isMfaRequired: true,
  },
  {
    id: 'test-mfa3@test.com',
    isMfaRequired: true,
  },
  {
    id: 'test_flour_admin@example.com',
    isMfaRequired: true,
  },
];
